import React from 'react';
import { Link } from 'react-router-dom';

// §7 / §15 — themed 404 with a link home, on the same dark theme.
export default function NotFound() {
  return (
    <main style={{ flex: 1, display: 'grid', placeItems: 'center', minHeight: '70vh' }}>
      <div className="container" style={{ textAlign: 'center' }}>
        <p style={{ font: 'var(--h1)', color: 'var(--accent-400)' }}>404</p>
        <h1 style={{ font: 'var(--h2)', marginTop: 8 }}>Page not found</h1>
        <p style={{ color: 'var(--text-400)', marginTop: 16 }}>
          The page you're looking for doesn't exist or has moved.
        </p>
        <p style={{ marginTop: 28 }}>
          <Link to="/">← Back to home</Link>
        </p>
      </div>
    </main>
  );
}
